@if (canShowMenu) {
<button
  type="button"
  pButton
  icon="pi pi-ellipsis-v"
  class="p-button-text p-button-rounded"
  style="color: black"
  (click)="onMenuToggle($event)"
></button>

<p-menu
  #menu
  [model]="items"
  [appendTo]="'body'"
  [popup]="true"
  (onHide)="onMenuHide()"
></p-menu>
}

<!-- Modal for Approve/Reject/Comment actions -->
<app-modal
  [visible]="showModal"
  [modalType]="modalType"
  [title]="modalTitle"
  [submitButtonLabel]="modalSubmitButtonLabel"
  [width]="'500px'"
  (visibleChange)="showModal = $event"
  (close)="onModalClose()"
  (submit)="onModalSubmit($event)"
></app-modal>
